import {
  Box as _Box,
  BoxProps,
  Flex as _Flex,
} from 'reflexbox/styled-components';
import styled from 'styled-components';

export { BoxProps };

export const Box = styled(_Box)<BoxProps>`
  min-width: unset;
`;

export const Flex = styled(_Flex)<BoxProps>`
  min-width: unset;
`;
